



























import { Component, Vue, Ref, PropSync, Prop, Watch } from "vue-property-decorator"
import { FormModel } from "ant-design-vue"
import corporateService from "@/services/corporate.service"
import { deepClone } from "@/utils"

const defaultForm = (): { id: number; code: number | undefined; name: string; remark: string } => ({
    id: 0,
    code: undefined,
    name: "",
    remark: ""
})

@Component({
    name: "CorporateEdit"
})
export default class CorporateEdit extends Vue {
    @PropSync("visible", { default: false })
    visible_: boolean

    @Prop({ type: String, default: "add" })
    fromType: string

    @Prop({ default: () => ({}) })
    lineData: object

    @Ref("ruleForm")
    refFrom: FormModel & { clearValidate: () => void }

    formModal: any = defaultForm()

    get changeTitle() {
        return this.fromType == "add" ? "新增公司主体" : "编辑公司主体"
    }

    get rules() {
        return {
            code: [{ required: true, message: "必填", trigger: "blur" }],
            name: [{ required: true, message: "必填", trigger: "blur" }]
        }
    }

    @Watch("visible")
    assignment() {
        if (this.fromType == "edit") {
            this.formModal = deepClone(this.lineData)
        } else {
            this.formModal = defaultForm()
        }
    }

    async addMode() {
        try {
            await this.refFrom.validate()
            await corporateService.createCorporate(this.formModal)
            this.$emit("upDataList")
            this.$message.success("新建成功")
            this.visible_ = false
            this.formModal = defaultForm()
            this.refFrom.clearValidate()
        } catch (error) {
            if (error) {
                this.$message.error(`创建失败！ ${error}`)
            }
        }
    }

    async editMode() {
        try {
            await this.refFrom.validate()
            await corporateService.updateCorporate(this.formModal)
            this.$emit("upDataList")
            this.$message.success("修改成功")
            this.visible_ = false
            this.refFrom.clearValidate()
        } catch (error) {
            if (error) {
                this.$message.error(`修改失败！ ${error}`)
            }
        }
    }

    handleOk() {
        if (this.fromType == "add") {
            this.addMode()
        } else {
            this.editMode()
        }
    }

    cancel() {
        this.visible_ = false
        this.formModal = defaultForm()
        this.refFrom.clearValidate()
    }
}
